import { render } from "./FilaRntrcPainel.vue?vue&type=template&id=70bcb3de&scoped=true"
import script from "./FilaRntrcPainel.vue?vue&type=script&lang=ts"
export * from "./FilaRntrcPainel.vue?vue&type=script&lang=ts"

import "./FilaRntrcPainel.vue?vue&type=style&index=0&id=70bcb3de&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70bcb3de"

export default script